<div class="main-content" *transloco="let t; read: 'conference'">

  <div class="layout-header p-d-flex p-ai-center p-jc-between">
    <div>
      <h1><app-back-button></app-back-button>{{ t('conference') }}</h1>
    </div>
    <div *ngIf="conference !== null" class="p-d-flex p-ai-center p-jc-between control-section">
      <div *ngIf="auth.isModerator()">
        <app-conference-controls></app-conference-controls>
      </div>
      <div>
        <app-timer [slot]="conference"></app-timer>
      </div>
    </div>
  </div>

  <div class="layout-content">
    <app-close-button></app-close-button>
    <div class="acr-card-body" style="padding-bottom: 6rem;">
      <div *ngIf="loading !== true">

        <app-candidate-selector
          [candidate]="candidate"
          (candidateChange)="changeCandidate($event)"
        ></app-candidate-selector>

        <div #tablecontainer>

        <p-table [value]="competences" dataKey="id" styleClass="p-datatable-sm">
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col style="min-width: 100px" />
              <!-- ONLINE TESTS -->
              <ng-container *ngFor="let onlinetest of onlinetests">
                <ng-container *ngIf="onlinetest.with_observers === true">
                  <ng-container *ngFor="let observer of observers">
                    <col [style]="'width: ' + valueWidth" />
                  </ng-container>
                </ng-container>
                <col [style]="'width: ' + valueWidth" style="min-width: 50px;" />
              </ng-container>
              <!-- EXERCISE PARTS -->
              <ng-container *ngFor="let exercisepart of exerciseparts">
                <col [style]="'width: ' + valueWidth" />
                <ng-container *ngFor="let observer of observers">
                  <col [style]="'width: ' + valueWidth" />
                </ng-container>
                <col [style]="'width: ' + valueWidth" />
              </ng-container>
              <!-- SUMS -->
              <col style="width: 50px" />
              <col style="min-width: 200px" />
              <col style="width: 2.5rem" />
            </colgroup>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('competence') }}</th>
              <!-- ONLINE TESTS -->
              <ng-container *ngFor="let onlinetest of onlinetests">
                <th [attr.colspan]="(onlinetest.with_observers !== true) ? 1 : observers.length + 2" class="vertical-line">{{ onlinetest.partner?.name }}<br />{{ onlinetest.name }}</th>
              </ng-container>
              <!-- EXERCISE PARTS -->
              <ng-container *ngFor="let exercisepart of exerciseparts">
                <th [attr.colspan]="observers.length + 2" class="vertical-line">{{ exercisepart.name }}<br />{{ exercisepart.partName }}</th>
              </ng-container>
              <!-- SUMS -->
              <th class="vertical-line p-text-center">{{ t('total') }}</th>
              <th class="vertical-line" colspan="2">{{ t('conference') }}</th>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <!-- ONLINE TESTS -->
              <ng-container *ngFor="let onlinetest of onlinetests">
                <th class="vertical-line p-text-center">
                  <fa-icon [icon]="faUser" pTooltip="{{ ac?.moderator?.fullname }}" tooltipPosition="top"></fa-icon>
                </th>
                <ng-container *ngIf="onlinetest.with_observers === true">
                  <ng-container *ngFor="let observer of observers">
                    <th class="p-text-center">
                      <fa-icon [icon]="faUser" pTooltip="{{ observer.fullname }}" tooltipPosition="top"></fa-icon>
                    </th>
                  </ng-container>
                  <th class="sum-line p-text-center"><fa-icon [icon]="faSigma"></fa-icon></th>
                </ng-container>
              </ng-container>
              <!-- EXERCISE PARTS -->
              <ng-container *ngFor="let exercisepart of exerciseparts">
                <th class="vertical-line p-text-center">
                  <fa-icon [icon]="faUser" pTooltip="{{ ac?.moderator?.fullname }}" tooltipPosition="top"></fa-icon>
                </th>
                <ng-container *ngFor="let observer of observers">
                  <th class="p-text-center">
                    <fa-icon [icon]="faUser" pTooltip="{{ observer.fullname }}" tooltipPosition="top"></fa-icon>
                  </th>
                </ng-container>
                <th class="sum-line p-text-center"><fa-icon [icon]="faSigma"></fa-icon></th>
              </ng-container>
              <!-- SUMS -->
              <th class="main-sum-line vertical-line">&nbsp;</th>
              <th class="vertical-line" style="min-width: 200px">&nbsp;</th>
              <th class="main-sum-line vertical-line">&nbsp;</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-competence>
            <tr [ngClass]="{ inactive: competence.value < 0 }">
              <td>{{ competence.getLang('name', language) }}</td>
              <!-- ONLINE TESTS -->
              <ng-container *ngFor="let onlinetest of onlinetests">
                <td class="vertical-line p-text-center">
                  {{ getSingleValueOnlinetest(competence.id, onlinetest.onlinetest_id, ac?.moderator?.hashed_id) | reportNumber }}
                </td>
                <ng-container *ngIf="onlinetest.with_observers === true">
                  <ng-container *ngFor="let observer of observers">
                    <td class="p-text-center">{{ getSingleValueOnlinetest(competence.id, onlinetest.onlinetest_id, observer.hashed_id) | reportNumber }}</td>
                  </ng-container>
                  <td class="sum-line p-text-center">{{ getSingleSumOnlinetest(competence.id, onlinetest.onlinetest_id) | reportNumber }}</td>
                </ng-container>
              </ng-container>
              <!-- EXERCISE PARTS -->
              <ng-container *ngFor="let exercisepart of exerciseparts">
                <td class="vertical-line p-text-center">{{ getSingleValue(competence.id, exercisepart.id, ac?.moderator?.hashed_id) | reportNumber }}</td>
                <ng-container *ngFor="let observer of observers">
                  <td class="p-text-center">{{ getSingleValue(competence.id, exercisepart.id, observer.hashed_id) | reportNumber }}</td>
                </ng-container>
                <td class="sum-line p-text-center">{{ getSingleSum(competence.id, exercisepart.id) | reportNumber }}</td>
              </ng-container>
              <!-- SUMS -->
              <td class="vertical-line main-sum-line p-text-center">
                <strong>{{ getCompetenceSum(competence.id) | reportNumber: 2 }}</strong>
              </td>
              <td class="vertical-line slider">
                <app-rating-slider
                  [(value)]="competence.value"
                  [min]="ratingtype.min_value"
                  [max]="ratingtype.max_value"
                  [step]="stepWidth"
                  [hide-value]="true"
                  (userChange)="saveResult()"
                  [disabled]="!isActive()"
                ></app-rating-slider>
              </td>
              <td class="vertical-line main-sum-line p-text-center">
                <strong class="slider-result">{{ competence.value | reportNumber }}</strong>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td class="sum-line">{{ t('total') }}</td>
              <!-- ONLINE TESTS -->
              <ng-container *ngFor="let onlinetest of onlinetests">
                <td class="vertical-line sum-line p-text-center">
                  {{ getUserSumOnlinetest(onlinetest.onlinetest_id, ac?.moderator?.hashed_id) | reportNumber }}
                </td>
                <ng-container *ngIf="onlinetest.with_observers === true">
                  <ng-container *ngFor="let observer of observers">
                    <td class="sum-line p-text-center">
                      {{ getUserSumOnlinetest(onlinetest.onlinetest_id, observer.hashed_id) | reportNumber }}
                    </td>
                  </ng-container>
                  <td class="sum-line p-text-center">
                    {{ getOnlinetestSum(onlinetest.onlinetest_id) | reportNumber }}
                  </td>
                </ng-container>
              </ng-container>
              <!-- EXERCISE PARTS -->
              <ng-container *ngFor="let exercisepart of exerciseparts">
                <td class="vertical-line sum-line p-text-center">
                  {{ getUserSum(exercisepart.id, ac?.moderator?.hashed_id) | reportNumber }}
                </td>
                <ng-container *ngFor="let observer of observers">
                  <td class="sum-line p-text-center">
                    {{ getUserSum(exercisepart.id, observer.hashed_id) | reportNumber }}
                  </td>
                </ng-container>
                <td class="sum-line p-text-center">
                  {{ getExercisepartSum(exercisepart.id) | reportNumber }}
                </td>
              </ng-container>
              <!-- SUMS -->
              <td class="vertical-line main-sum-line p-text-center">
                <strong>{{ getMainSum() | reportNumber: 2 }}</strong>
              </td>
              <td class="vertical-line sum-line"></td>
              <td class="vertical-line main-sum-line p-text-center">{{ getMainConferenceSum() | reportNumber }}</td>
            </tr>
            <tr>
              <td>
                <label for="recommendation">{{ t('recommendation') }}</label>
              </td>
              <td colspan="100">
                <div class="p-fluid">
                  <p-dropdown
                    id="recommendation"
                    [options]="recommendations"
                    [(ngModel)]="recommendation"
                    optionLabel="name"
                    placeholder="Bitte wählen"
                    [disabled]="!isActive()"
                    (onChange)="saveResult()"
                  ></p-dropdown>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        </div>

        <p class="p-mt-4 p-mb-4 p-text-right">
          <button pButton (click)="exportToExcel()" class="p-button-sm" type="button" icon="pi pi-chart-bar" label="{{ t('export_to_excel') }}"></button>
        </p>

      </div>

      <div class="p-d-flex p-jc-center p-mt-4 p-mb-4" *ngIf="loading === true">
        <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      </div>
    </div>
  </div>
</div>
